<template>
  <button type="button" class="btn-destroy">
    <i v-if="icon" :class="icon" />
    <span v-if="icon" class="space-icon" />{{ label }}
  </button>
</template>

<script>
export default {
  name: "dangerButton",
  props: ["label", "icon"],
};
</script>